import { useCallback, useEffect, useRef } from "react";

/**
 * Хук для анимации с помощью requestAnimationFrame
 */
export const useAnimationFrame = (
  animationHandler: () => void,
  fps = 60,
  deps: unknown
) => {
  const frameRef = useRef(0);
  const lastFrameTimeRef = useRef(performance.now());

  const fpsInterval = 1000 / fps;

  const animate = useCallback(() => {
    const now = performance.now();
    const elapsed = now - lastFrameTimeRef.current;

    if (elapsed > fpsInterval) {
      animationHandler();
      lastFrameTimeRef.current = now;
    }

    frameRef.current = requestAnimationFrame(animate);
  }, [animationHandler, fpsInterval]);

  useEffect(() => {
    frameRef.current = requestAnimationFrame(animate);

    return () => cancelAnimationFrame(frameRef.current);
  }, [animate, fps, deps]);
};
